// novem wordmark — text lockup reused by the nav + footer. Mirrors the
// customer-web LeftRail brand pattern (a square accent mark + the
// "novem" + emerald "HR" + an "AI" pill), restyled for the marketing
// surface where the wordmark uses the Outfit DISPLAY face (marketing-only,
// FRONTEND_PORT_MAP §7). Every glyph comes from the i18n bundle so the
// no-literal lint stays authoritative; the wordmark reads identically in
// both locales (it is a brand name, not translated prose).

import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

export interface WordmarkProps {
  /** Wordmark glyph height in px; the AI pill scales with it. */
  readonly size?: number;
  readonly className?: string;
}

export function Wordmark({ size = 22, className }: WordmarkProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <span
        aria-hidden="true"
        className="flex aspect-square items-center justify-center rounded-[8px] bg-[var(--accent)] font-sans font-bold leading-none text-[var(--fg-on-accent)]"
        style={{ width: size * 1.3, height: size * 1.3, fontSize: size * 0.62 }}
      >
        {t("app.wordmark_base").slice(0, 1)}
      </span>
      <span
        className="font-display font-semibold tracking-[-0.02em] text-[var(--fg-primary)]"
        style={{ fontSize: size }}
      >
        {t("app.wordmark_base")}
        <span className="text-[var(--accent)]">{t("app.wordmark_hr")}</span>{" "}
        <span
          className="ml-0.5 inline-block rounded-[6px] bg-[var(--mkt-tint-accent)] px-1.5 py-0.5 align-middle font-sans font-semibold leading-none text-[var(--accent-hover)]"
          style={{ fontSize: size * 0.55 }}
        >
          {t("app.wordmark_ai_badge")}
        </span>
      </span>
    </span>
  );
}
